// Copy for the Attendance Allowance claim conversation. Keni asks the claim
// questions she can over chat; anything she can't (a photo, a signature) she
// hands off to a task. Mock content — a representative slice of the real 64-
// question AA form, not the whole thing.

export type ClaimQuestion = {
  // What Keni asks.
  keni: string;
  // Quick-reply chips, when the answer is a short choice. Free text otherwise.
  replies?: string[];
  // Placeholder for the free-text answer.
  placeholder?: string;
};

export const CLAIM_INTRO =
  'Let’s fill in Mum’s Attendance Allowance claim. I’ll ask what I can and pop anything else in your tasks — you won’t have to repeat what you’ve already told me.';

export const CLAIM_QUESTIONS: ClaimQuestion[] = [
  {
    keni: 'First — what’s Mum’s full legal name?',
    placeholder: 'Her full legal name',
  },
  { keni: 'And her date of birth?', placeholder: 'DD / MM / YYYY' },
  {
    keni: 'What’s Mum’s National Insurance number?',
    placeholder: 'QQ 12 34 56 C',
  },
  {
    keni: 'Does Mum need help during the night?',
    replies: ['Yes', 'No', 'Sometimes'],
  },
  {
    keni: 'Has she been in hospital in the last four weeks?',
    replies: ['Yes', 'No'],
  },
  {
    keni: 'And who should we pay the benefit to?',
    replies: ['Mum', 'Me', 'Someone else'],
  },
];

// The un-askable bits — handed off to tasks (the photo upload is the exemplar).
export const CLAIM_HANDOFF =
  'That’s everything I can ask. Two things I can’t do over chat, so I’ve added them to your tasks:';

export const CLAIM_HANDOFF_ITEMS = [
  'A photo of Mum’s prescription',
  'Mum’s signature',
];

export const CLAIM_DONE =
  'Once those are done, Mum’s claim is ready to review and submit — you’ll find it under Claims.';

export const CLAIM = {
  title: 'Attendance Allowance claim',
  speaking: 'Keni is speaking…',
  listening: 'Your turn',
  placeholder: 'Type your answer…',
  doneCta: 'See my tasks',
};
